module.exports = __webpack_public_path__ + "img/MX-C048A-BS.864e3d77.png";